import type { TrPageConfigInterface } from '@core/utils/TrPageConfig.interface'
import { useLanguage } from '@core/composables/language/useLanguage'

const Names = {
  fr: 'francais',
  en: 'french'
}

const Config: TrPageConfigInterface = {
  name: Names.fr,
  path: '/fr/:catchAll(.*)?',
  beforeEnter: async (to, from, next) => {
    await useLanguage().useFr()

    if (to.params.catchAll) {
      next({ path: to.params.catchAll, query: to.query })
    } else {
      next({ name: 'home', query: to.query })
    }
  }
}

export { Config }
